import { ISagaModule } from "redux-dynamic-modules-saga";
import { customizationReducer } from "./state/reducer";
import { CustomizationsState } from "./types";

export const getCustomizationModule = (): ISagaModule<CustomizationsState> => ({
    id: "customizationSettings",
    reducerMap: {
        customization: customizationReducer,
    },
});
